import { render, staticRenderFns } from "./NomenclatureSettingsDialog.vue?vue&type=template&id=11ab5988&scoped=true"
import script from "./NomenclatureSettingsDialog.vue?vue&type=script&lang=js"
export * from "./NomenclatureSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./NomenclatureSettingsDialog.vue?vue&type=style&index=0&id=11ab5988&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ab5988",
  null
  
)

export default component.exports